export const factCategories = [
  "Общая информация",
  "Мощность",
  "Инфраструктура",
  "Команда",
  "Медицинские направления",
  "Партнёры",
  "Услуги",
  "Технологии",
  "География",
  "Статус запуска",
] as const;

export const assetCategories = [
  { id: "logo", label: "Логотипы" },
  { id: "brandbook", label: "Брендбук" },
  { id: "presentation", label: "Презентации" },
  { id: "photo", label: "Фотографии" },
  { id: "video", label: "Видео" },
  { id: "template", label: "Шаблоны" },
  { id: "document", label: "Документы" },
  { id: "archive", label: "Архив" },
] as const;

export const wordingFormats = [
  { id: "one-line", label: "В одном предложении" },
  { id: "short-description", label: "Короткое описание" },
  { id: "full-description", label: "Расширенное описание" },
  { id: "social-media", label: "Социальные сети" },
  { id: "presentation", label: "Презентация" },
  { id: "recruitment", label: "Найм" },
  { id: "internal", label: "Внутреннее использование" },
] as const;

export const languageLabels = {
  ru: "Русский",
  uz: "O‘zbekcha",
  en: "English",
} as const;
